// extracted by mini-css-extract-plugin
export var form_element = "styles-module--form_element--CuYUn";
export var icon = "styles-module--icon--lpxj+";
export var icon_close = "styles-module--icon_close--G20V1";
export var icon_visible = "styles-module--icon_visible--h+i3j";
export var input_wrapper = "styles-module--input_wrapper--P4nBf";
export var notValid = "styles-module--notValid--FmB1j";